
class ThemeSelect extends HTMLElement {
  static formAssociated = true;
  static OPEN_ATTRIBUTE = "open";
  #options = [];
  #shadow;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#options = this.querySelectorAll("option");
    this.updateSelectedOption();
    this.value = this.selectedOption?.value ?? "";
    this.#shadow = this.attachShadow({ mode: "open" });

    this.internals = this.attachInternals();
    this.render();

    document.body.addEventListener("click", (e) => {
      if (this.isOpen()) {
        const clickInside = this.contains(e.target);
        if (!clickInside) {
          this.close();
        }
      }
    });
  }
  updateSelectedOption() {
    const selectedOption = Array.from(this.#options).find((o) => o.hasAttribute("selected"));
    const optionFromValue = Array.from(this.#options).find((o) => o.value == this.value);
    const firstOption = this.#options.length > 0 ? this.#options[0] : null;
    this.selectedOption = selectedOption || optionFromValue || null;
    if (!this.placeholder && !selectedOption && !optionFromValue) {
      this.selectedOption = firstOption;
    }
  }
  render() {
    if (!this.#shadow) {
      return;
    }
    this.#shadow.innerHTML = `
    <div part="selected-value">
        <span>${!!this.selectedOption ? this.selectedOption.innerHTML : `<span part="placeholder">${this.placeholder}</span>`}</span>
      </div>
      <div part="dropdown">
        ${Array.from(this.#options)
          .map(
            (o) =>
              `<div shadow-option="" part="option ${this.selectedOption == o ? " selected"="" :="" ""}="" ${this.placeholder="==" o.value="" ?="" "placeholder"="" ${o.disabled="" "disabled"="" ""}"="" value="${o.value}" ${this.selectedOption="=" o="" "selected"="">${o.innerHTML}</div>`,
          )
          .join("")}
      </div>
    `;
    const shadowOptions = this.#shadow.querySelectorAll("[shadow-option]");
    shadowOptions.forEach((option) => {
      option.addEventListener("click", () => {
        this.value = option.getAttribute("value");
        this.selectOptionByValue(this.value);
        this.updateSelectedOption();
        this.update();
        this.close();
      });
    });

    const shadowSelectedValue = this.#shadow.querySelector('[part="selected-value"]');
    shadowSelectedValue.addEventListener("click", () => {
      this.toggle();
    });
  }
  selectOptionByValue(value) {
    this.#options.forEach((o) => (o.value == value ? o.setAttribute("selected", true) : o.removeAttribute("selected")));
  }

  update() {
    this.dispatchEvent(new Event("change"));
    this.render();
  }
  close() {
    this.removeAttribute(ThemeSelect.OPEN_ATTRIBUTE);
  }
  open() {
    this.setAttribute(ThemeSelect.OPEN_ATTRIBUTE, true);
  }
  isOpen() {
    return this.hasAttribute(ThemeSelect.OPEN_ATTRIBUTE);
  }
  toggle() {
    this.isOpen() ? this.close() : this.open();
  }
  set value(v) {
    this.setAttribute("value", v);
    this.internals?.setFormValue(v);
  }
  get placeholder() {
    return this.getAttribute("placeholder");
  }

  get value() {
    return this.selectedOption?.value ?? "";
  }
  get form() {
    return this.internals?.form;
  }
  get type() {
    return this.localName;
  }

  static get observedAttributes() {
    return ["name", "value", "id", "open"];
  }
  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (property === ThemeSelect.OPEN_ATTRIBUTE) {
      this.hasAttribute(ThemeSelect.OPEN_ATTRIBUTE) ? this.open() : this.close();
      return;
    }
    this[property] = newValue;

    if (property === "value") {
      this.selectOptionByValue(newValue);
      this.updateSelectedOption();
      this.render();
    }
  }
}
customElements.define("theme-select", ThemeSelect);

class SortBySelect extends ThemeSelect {
  constructor() {
    super();
  }
  updateDeepLinking() {
    const newUrl = new URL(location.href);
    newUrl.searchParams.set("sort_by", this.sort_by);
    history.replaceState(null, "", newUrl.href);
  }
  updateDOM() {
    this.sort_by = this.getAttribute("value");
    const newUrl = new URL(location.href);
    newUrl.searchParams.set("sort_by", this.sort_by);
    this.updateDeepLinking();
    const section = this.closest("[data-section-id]");
    if (!!section) {
      const section_id = section.dataset.sectionId;
      if (!!section_id) {
        section.classList.add("loading");
        newUrl.searchParams.set("section_id", section_id);
        fetch(newUrl.href, {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          method: "GET",
        })
          .then((response) => response.text())
          .then((data) => {
            const template = document.createElement("template");
            template.innerHTML = data.trim();
            const old_collection_grid = section.querySelector("#collection-grid");
            const new_collection_grid = template.content.querySelector("#collection-grid");
            if (!!old_collection_grid && !!new_collection_grid) {
              old_collection_grid.replaceWith(new_collection_grid);
            }
            const old_collection_filter = section.querySelector("#collection-filter");
            const new_collection_filter = template.content.querySelector("#collection-filter");
            if (!!old_collection_filter && !!new_collection_filter) {
              old_collection_filter.innerHTML = new_collection_filter.innerHTML;
            }
            const old_collection_pagination = section.querySelector("#collection-pagination");
            const new_collection_pagination = template.content.querySelector("#collection-pagination");
            if (!!old_collection_pagination && !!new_collection_pagination) {
              old_collection_pagination.replaceWith(new_collection_pagination);
            }
            window.dispatchEvent(new CustomEvent("collection::updated"));
            if (!!section) {
              section.classList.remove("loading");
            }
          })
          .catch(function (err) {
            if (!!section) {
              section.classList.remove("loading");
            }
            console.error(err);
          });
      }
    }
  }
  connectedCallback() {
    super.connectedCallback();
    const that = this;
    that.sort_by = that.getAttribute("value");
    super.addEventListener("change", that.updateDOM.bind(that));
  }
}
customElements.define("sort-by-select", SortBySelect);